import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import Search from '../Components/Images/search-lg.svg'
import refresh from '../Components/Images/refresh.svg'
import Select from 'react-select';
// import Increase from '../Components/Images/Increase.svg'
// import Decrease from '../Components/Images/decrease.png'
import { IoArrowDownSharp } from 'react-icons/io5';
import { Context } from '../Context/Context';
import ViewTransactionDetailsBar from './ViewTransactionDetailsBar';
import ViewDetailsBar from './ViewDetailsBar';
import { GoDotFill } from 'react-icons/go';
import { Link } from 'react-router-dom'
// import isEqual from 'lodash.isequal';

function filterPaymentsByDate(payments, filterType) {
    const now = new Date();

    return payments.filter(payment => {
        const paymentDate = new Date(payment.date_created);

        switch (filterType) {
            case 'total':
                return true; // return all payments
            case 'lastWeek': {
                const oneWeekAgo = new Date(now);
                oneWeekAgo.setDate(now.getDate() - 7);
                return paymentDate >= oneWeekAgo && paymentDate <= now;
            }
            case '3daysAgo': {
                const threeDaysAgo = new Date(now);
                threeDaysAgo.setDate(now.getDate() - 3);
                return paymentDate >= threeDaysAgo && paymentDate <= now;
            }
            case '5daysAgo': {
                const fiveDaysAgo = new Date(now);
                fiveDaysAgo.setDate(now.getDate() - 5);
                return paymentDate >= fiveDaysAgo && paymentDate <= now;
            }
            case 'lastMonth': {
                const startOfThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                const startOfLastMonth = new Date(startOfThisMonth);
                startOfLastMonth.setMonth(startOfThisMonth.getMonth() - 1);
                const endOfLastMonth = new Date(startOfThisMonth);
                endOfLastMonth.setDate(0); // last day of previous month
                return paymentDate >= startOfLastMonth && paymentDate <= endOfLastMonth;
            }
            default:
                return false;
        }
    });
}

const Transactions = ({ verified }) => {

    // const navigate = useNavigate();
    // const location = useLocation()

    const customStyles = {
        indicatorSeparator: () => ({
            display: 'none',
        }),
        control: (base) => ({
            ...base,
            borderColor: '#F3F0F7',
            borderWidth: '1.2px',
            boxShadow: '0 1px 2px 0 #1D1C1F0D',
            borderRadius: '10px',
            width: '120px'
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0 0px',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 999,
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#F3F0F7' : 'white',
            color: 'black',
            cursor: 'pointer',
        }),
    }

    const option1 = [
        { value: 'total', label: <p className='text-[14px]'>Total</p> },
        { value: 'lastWeek', label: <p className='text-[14px]'>Last week</p> },
        { value: '3daysAgo', label: <p className='text-[14px]'>3 days ago</p> },
        { value: '5daysAgo', label: <p className='text-[14px]'>5 days ago</p> },
        { value: 'lastMonth', label: <p className='text-[14px]'>Last month</p> }
    ]
    const option2 = [
        { value: 'total', label: <p className='text-[14px]'>Total</p> },
        { value: 'lastWeek', label: <p className='text-[14px]'>Last week</p> },
        { value: '3daysAgo', label: <p className='text-[14px]'>3 days ago</p> },
        { value: '5daysAgo', label: <p className='text-[14px]'>5 days ago</p> },
        { value: 'lastMonth', label: <p className='text-[14px]'>Last month</p> }
    ]
    const option3 = [
        { value: 'total', label: <p className='text-[14px]'>Total</p> },
        { value: 'lastWeek', label: <p className='text-[14px]'>Last week</p> },
        { value: '3daysAgo', label: <p className='text-[14px]'>3 days ago</p> },
        { value: '5daysAgo', label: <p className='text-[14px]'>5 days ago</p> },
        { value: 'lastMonth', label: <p className='text-[14px]'>Last month</p> }
    ];

    // const [TransactionType, setTransactionType] = useState('all')
    const { setSelectedTransactionDetails, handleViewTransactionDetails, handleViewDetails, viewDetails, viewTransactionDetails } = useContext(Context)
    const [searchQuery, setSearchQuery] = useState('');
    const [transaction, setTransaction] = useState([])
    const [transactionCredit, setTransactionCredit] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const sentAmount = JSON.parse(localStorage.getItem('UserPayments'))
    const [filteredPayments, setFilteredPayments] = useState([])
    const [selectedMoneySent, setSelectedMoneySent] = useState(option3[0]);
    const [selectedTotalTransaction, setSelectedTotalTransaction] = useState(option1[0]);
    const [selectedInflow, setSelectedInflow] = useState(option2[0]);
    const [filteredCount, setFilteredCount] = useState(0);

    const Spinner = () => (
        <div className="w-6 h-6 border-4 my-4 border-t-transparent border-[#542d9d] rounded-full animate-spin"></div>
    );

    // const filterTransactionCredit = () => {
    //     if (!transactionCredit?.total_credit) return [];

    //     const now = new Date();

    //     return transactionCredit.total_credit.filter(txn => {
    //         const txnDate = new Date(txn.created_at); // or txn.date if that's the field name
    //         const value = selectedInflow.value;

    //         if (value === 'lastWeek') {
    //             const oneWeekAgo = new Date();
    //             oneWeekAgo.setDate(now.getDate() - 7);
    //             return txnDate >= oneWeekAgo;
    //         }

    //         if (value === '3daysAgo') {
    //             const threeDaysAgo = new Date();
    //             threeDaysAgo.setDate(now.getDate() - 3);
    //             return txnDate >= threeDaysAgo;
    //         }

    //         if (value === '5daysAgo') {
    //             const fiveDaysAgo = new Date();
    //             fiveDaysAgo.setDate(now.getDate() - 5);
    //             return txnDate >= fiveDaysAgo;
    //         }

    //         if (value === 'lastMonth') {
    //             const oneMonthAgo = new Date();
    //             oneMonthAgo.setMonth(now.getMonth() - 1);
    //             return txnDate >= oneMonthAgo;
    //         }

    //         return true; // total
    //     });
    // };

    const handleTransactionClick = (id) => {
        localStorage.setItem('TransactionID', id);
    };

    const handleSearch = (query) => {
        setSearchQuery(query);  // Update the search query state
    };

    const [isSmScreen, setIsSmScreen] = useState(window.innerWidth < 640);

    useEffect(() => {
        const handleResize = () => {
            setIsSmScreen(window.innerWidth < 640);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchAllData = useCallback(async () => {
        const token = localStorage.getItem('token');
        if (!token) return;


        setIsLoading(true);

        try {

            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/transactions`, {
                method: "GET",
                headers: { Authorization: `Token ${token}` },
            });
            const data = await res.json();

            if (!verified) {
                setTransaction([])
            } else {
                setTransaction(data);
            }

            const creditRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/transactions/total-credit`, {
                method: "GET",
                headers: { Authorization: `Token ${token}` },
            });

            const creditData = await creditRes.json();
            setTransactionCredit(creditData)
            console.log('total credit', creditData);


            // Filter pending transactions
            const pendingTxns = data.filter(txn => (txn.payment.status || '').toLowerCase() !== 'completed');

            // If no pending, clear status and stop here
            if (pendingTxns?.length === 0) {
                return;
            }

            // Fetch pending statuses
            await Promise.all(
                pendingTxns.map(async (txn) => {
                    const paymentId = txn?.payment?.id;
                    if (!paymentId) {
                        return { id: txn.id, status: 'Missing Payment ID' };
                    }

                    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/payments/${paymentId}/get_data`, {
                        method: "GET",
                        headers: { Authorization: `Token ${token}` },
                    });

                    if (!res.ok) {
                        return { id: txn.id, status: 'Error' };
                    }

                    const text = await res.text();
                    if (!text) return { id: txn.id, status: 'Empty' };

                    const data = JSON.parse(text);
                    return { id: txn.id, status: data.status };
                })
            );


        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    }, [verified]);

    useEffect(() => {
        if (verified) {
            fetchAllData();
        }
    }, [fetchAllData, verified]);

    const currencyLogos = useMemo(() => ({
        USD: 'https://flagcdn.com/w40/us.png',
        ZAR: 'https://flagcdn.com/w40/za.png',
        NGN: 'https://flagcdn.com/w40/ng.png',
        GBP: 'https://flagcdn.com/w40/gb.png',
        CAD: 'https://flagcdn.com/w40/ca.png',
        GHS: 'https://flagcdn.com/w40/gh.png',
        KES: 'https://flagcdn.com/w40/ke.png',
        CNY: 'https://flagcdn.com/w40/cn.png',
        INR: 'https://flagcdn.com/w40/in.png',
        PHP: 'https://flagcdn.com/w40/ph.png',
        PKR: 'https://flagcdn.com/w40/pk.png',
        SEK: 'https://flagcdn.com/w40/se.png',
        CHF: 'https://flagcdn.com/w40/ch.png',
        EUR: 'https://flagcdn.com/w40/eu.png',
        JPY: 'https://flagcdn.com/w40/jp.png',
        AUD: 'https://flagcdn.com/w40/au.png',
        BRL: 'https://flagcdn.com/w40/br.png',
        MXN: 'https://flagcdn.com/w40/mx.png',
        RUB: 'https://flagcdn.com/w40/ru.png',
        NOK: 'https://flagcdn.com/w40/no.png',
        DKK: 'https://flagcdn.com/w40/dk.png',
        SGD: 'https://flagcdn.com/w40/sg.png',
        HKD: 'https://flagcdn.com/w40/hk.png',
        KRW: 'https://flagcdn.com/w40/kr.png',
        AED: 'https://flagcdn.com/w40/ae.png',
        SAR: 'https://flagcdn.com/w40/sa.png',
        TRY: 'https://flagcdn.com/w40/tr.png',
        EGP: 'https://flagcdn.com/w40/eg.png',
    }), []);

    // const roundUp = (value, decimals = 2) => {
    //     const factor = Math.pow(10, decimals);
    //     return Math.ceil(value * factor) / factor;
    // };
    const prevFilteredRef = useRef([]);

    useEffect(() => {
        if (!Array.isArray(sentAmount)) {
            if (prevFilteredRef.current.length !== 0) {
                setFilteredPayments([]);
                prevFilteredRef.current = [];
            }
            return;
        }

        if (!selectedMoneySent) return;

        if (!verified) {
            if (prevFilteredRef.current.length !== 0) {
                setFilteredPayments([]);
                prevFilteredRef.current = [];
            }
            return;
        }

        const filtered = filterPaymentsByDate(sentAmount, selectedMoneySent.value);

        // Check if the new filtered result is different
        const isSame =
            JSON.stringify(filtered) === JSON.stringify(prevFilteredRef.current);

        if (!isSame) {
            setFilteredPayments(filtered);
            prevFilteredRef.current = filtered;
        }
    }, [selectedMoneySent, sentAmount, verified]);

    const handleChange1 = useCallback((selectedOption) => {

        // if (!verified) {
        //     navigate('/dashboard', {
        //         replace: true,
        //         state: {
        //             error: 'You need to fill in your KYC data to continue',
        //             from: location.pathname,
        //         },
        //     });
        //     return;
        // }
        setSelectedTotalTransaction(selectedOption);

        if (!transaction || transaction.length === 0) return;

        const now = new Date();
        let filtered = [];

        switch (selectedOption.value) {
            case 'lastWeek':
                filtered = transaction.filter(txn => {
                    const date = new Date(txn.created_at || txn.timestamp); // Adjust to your date field
                    const oneWeekAgo = new Date();
                    oneWeekAgo.setDate(now.getDate() - 7);
                    return date >= oneWeekAgo && date <= now;
                });
                break;
            case '3daysAgo':
                filtered = transaction.filter(txn => {
                    const date = new Date(txn.created_at || txn.timestamp);
                    const threeDaysAgo = new Date();
                    threeDaysAgo.setDate(now.getDate() - 3);
                    return date >= threeDaysAgo && date <= now;
                });
                break;
            case '5daysAgo':
                filtered = transaction.filter(txn => {
                    const date = new Date(txn.created_at || txn.timestamp);
                    const fiveDaysAgo = new Date();
                    fiveDaysAgo.setDate(now.getDate() - 5);
                    return date >= fiveDaysAgo && date <= now;
                });
                break;
            case 'lastMonth':
                filtered = transaction.filter(txn => {
                    const date = new Date(txn.created_at || txn.timestamp);
                    const oneMonthAgo = new Date();
                    oneMonthAgo.setMonth(now.getMonth() - 1);
                    return date >= oneMonthAgo && date <= now;
                });
                break;
            case 'total':
            default:
                filtered = transaction;
        }

        setFilteredCount(filtered.length);
    }, [transaction]);

    useEffect(() => {
        if (transaction && transaction.length > 0) {
            handleChange1(selectedTotalTransaction);
        }
    }, [transaction, selectedTotalTransaction, handleChange1]);

    const handleChange2 = (selectedOption) => {
        setSelectedInflow(selectedOption);
    }
    const handleChange3 = (selectedOption) => {
        setSelectedMoneySent(selectedOption);
    }

    // const filteredTransaction = TransactionType === 'all'
    //     ? transaction.filter(transact => {
    //         const formattedDate = new Date(transact.date_created).toLocaleDateString("en-GB", {
    //             day: '2-digit',
    //             month: 'short',
    //             year: 'numeric',
    //         }).toLowerCase();
    //         return (
    //             formattedDate.includes(searchQuery.toLowerCase()) ||
    //             (transact.type?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //             (transact.amount?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //             (transact.payment.beneficiary.full_name?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //             (transact.currency?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //             (transact.payment.status?.toLowerCase() || '').includes(searchQuery.toLowerCase())
    //         )
    //     })
    //     : transaction.filter(transact => {
    //         const formattedDate = new Date(transact.date_created).toLocaleDateString("en-GB", {
    //             day: '2-digit',
    //             month: 'short',
    //             year: 'numeric',
    //         }).toLowerCase();
    //         if (TransactionType === 'ngn') {
    //             return (
    //                 transact.payment.account_type === 'fiat' && (
    //                     formattedDate.includes(searchQuery.toLowerCase()) ||
    //                     (transact.type?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //                     (transact.amount?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //                     (transact.payment.beneficiary.full_name?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //                     (transact.currency?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //                     (transact.payment.status?.toLowerCase() || '').includes(searchQuery.toLowerCase())
    //                 )
    //             );
    //         } else if (TransactionType === 'usd') {
    //             const formattedDate = new Date(transact.date_created).toLocaleDateString("en-GB", {
    //                 day: '2-digit',
    //                 month: 'short',
    //                 year: 'numeric',
    //             }).toLowerCase();
    //             return (
    //                 ['USDT', 'SOL', 'BTC', 'USDC', 'BNB', 'ETH'].includes(transact.payment.cryptocurrency_type) && (
    //                     formattedDate.includes(searchQuery.toLowerCase()) ||
    //                     (transact.type?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //                     (transact.amount?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //                     (transact.payment.beneficiary.full_name?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //                     (transact.currency?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    //                     (transact.payment.status?.toLowerCase() || '').includes(searchQuery.toLowerCase())
    //                 ));
    //         }
    //         return true;
    //     });

    return (
        <div>
            <div
                className={`w-full top-0 h-[200%] absolute z-10 ${viewTransactionDetails || viewDetails ? 'bg-black/30' : 'hidden'}`}
                onClick={viewDetails ? handleViewDetails : handleViewTransactionDetails}
            ></div>
            <div className='lg:p-10 py-10 px-4'>
                <div className='pb-5'>
                    <div className='flex justify-between items-center mb-2 sp:mb-0'>
                        <div className='flex items-center gap-2'>
                            <p className='text-[28px] font-semibold'>Transactions</p>
                        </div>
                        <div className='flex md:items-center items-start gap-9'>
                            <img
                                src={refresh}
                                alt=""
                                onClick={fetchAllData}
                                className='cursor-pointer'
                            />
                            {/* <img className='lg:block hidden cursor-pointer' src={Search} alt="" />
                            <img className='lg:block hidden cursor-pointer' src={Bell} alt="" /> */}
                            {/* <img className='w-10' src={Add} alt="" /> */}
                        </div>
                    </div>
                    <p className='text-[16px] font-normal pr-10 text-[#525154]'>Track and manage all your payments, transfers, and conversions in one place.</p>
                </div>
                <div className='flex gap-6 border-b-[1.3px]'>
                    {/* <p
                        onClick={() => setTransactionType('all')}
                        className={TransactionType === 'all' ? 'text-[#491f97] border-b-[#491f97] border-b-2 cursor-pointer py-3 transition-colors duration-700 font-medium' : 'font-medium text-[#525154] cursor-pointer py-3'}
                    >
                        All accounts
                    </p>
                    <div
                        onClick={() => setTransactionType('usd')}
                        className={TransactionType === 'usd' ? 'text-[#491f97] border-b-[#491f97] border-b-2 cursor-pointer py-3 transition-colors duration-700 font-medium flex gap-2' : 'font-medium text-[#525154] cursor-pointer py-3 flex gap-2'}
                    >
                        <img className='w-[15px] h-[12px] rounded-[2px] mt-[6px]' src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Flag_of_the_United_States_%28DoS_ECA_Color_Standard%29.svg/250px-Flag_of_the_United_States_%28DoS_ECA_Color_Standard%29.svg.png" alt="" />
                        <p>USD</p>
                    </div>
                    <div
                        onClick={() => setTransactionType('ngn')}
                        className={TransactionType === 'ngn' ? 'text-[#491f97] border-b-[#491f97] border-b-2 cursor-pointer py-3 transition-colors duration-700 font-medium flex gap-2' : 'font-medium text-[#525154] cursor-pointer py-3 flex gap-2'}
                    >
                        <img className='w-[15px] h-[12px] rounded-[2px] mt-[6px]' src="https://cdn.britannica.com/68/5068-050-53E22285/Flag-Nigeria.jpg" alt="" />
                        <p>NGN</p>
                    </div> */}
                </div>
                <div>
                    <p className='text-[#1D1C1F] text-[18px] my-7 font-medium'>Overview</p>
                    <div className='flex md:flex-row flex-col lg:gap-6 gap-4'>
                        <div className='w-full border-[1.2px] rounded-lg pr-5 border-[#D0D5DD] p-3'>
                            <div className='flex items-center justify-between'>
                                <p className='flex items-center gap-1 text-[14px] text-[#78757A]'>
                                    Total transactions
                                </p>
                                <Select
                                    styles={customStyles}
                                    options={option1}
                                    onChange={handleChange1}
                                    value={selectedTotalTransaction}
                                    isSearchable={false}
                                />
                            </div>
                            <div>
                                <div className='text-[36px] font-medium font'>
                                    {isLoading ? (
                                        <Spinner />
                                    ) : (
                                        filteredCount
                                    )}
                                </div>
                                {/* <p className='bg-green-200 border-[1.2px] flex items-center gap-1 justify-center border-green-500 w-20 py-1 rounded-md text-green-500 text-center'>
                                    +25% <img src={Increase} alt="" />
                                </p> */}
                            </div>
                        </div>
                        <div className='w-full border-[1.2px] rounded-lg pr-5 border-[#D0D5DD] p-3'>
                            <div className='flex justify-between'>
                                <p className='flex items-center gap-1 text-[14px] text-[#78757A]'>
                                    Inflow
                                </p>
                                <Select
                                    styles={customStyles}
                                    options={option2}
                                    onChange={handleChange2}
                                    value={selectedInflow}
                                    isSearchable={false}
                                />
                            </div>
                            <div>
                                <div className='text-[36px] font-medium font'>
                                    {isLoading ? (
                                        <Spinner />
                                    ) : (
                                        <>
                                            ${transactionCredit.total_credit || 0}
                                        </>
                                    )}
                                </div>
                                {/* <p className='bg-green-200 border-[1.2px] flex items-center gap-1 justify-center border-green-500 w-20 py-1 rounded-md text-green-500 text-center'>
                                    +25% <img src={Increase} alt="" />
                                </p> */}
                            </div>
                        </div>
                        <div className='w-full border-[1.2px] rounded-lg pr-5 border-[#D0D5DD] p-3'>
                            <div className='flex justify-between'>
                                <p className='flex items-center gap-1 text-[14px] text-[#78757A]'>
                                    Outflow
                                </p>
                                <Select
                                    styles={customStyles}
                                    options={option3}
                                    onChange={handleChange3}
                                    value={selectedMoneySent}
                                    isSearchable={false}
                                />
                            </div>
                            <div>
                                <div className='text-[36px] font-medium font'>
                                    {isLoading ? (
                                        <Spinner />
                                    ) : (
                                        <>
                                            {/* {selectedCurrency?.value === 'USD' && '$'} */}
                                            $
                                            {filteredPayments?.length === 0
                                                ? 0
                                                : filteredPayments.reduce((sum, p) => sum + Number(p.amount), 0)}
                                        </>
                                    )}
                                </div>
                                {/* <p className='bg-red-200 border-[1.2px] flex items-center gap-1 justify-center border-[#EF4444] w-20 py-1 rounded-md text-[#EF4444] text-center'>
                                    +25% <img src={Decrease} alt="" />
                                </p> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='mt-[50px]'>
                    <div className='relative'>
                        <input
                            type="text"
                            placeholder="Search transaction by date, type, currency, sender, status or amount"
                            value={searchQuery}
                            onChange={(e) => handleSearch(e.target.value)}
                            className="px-4 py-2 border-none outline-none border-gray-300 w-full placeholder:text-[#667085] placeholder:text-[14px] ml-5 rounded-md"
                        />
                        <img src={Search} alt="" className='absolute top-2' />
                    </div>
                    <div className='mt-[15px] '>
                        <div className='sm:grid md:grid-cols-9 sm:grid-cols-8 sp:grid-cols-7 flex justify-between items-center gap-5 border-t border-b text-[#667085] border-[#EAECF0] py-[14px] px-4 text-[14px] font-normal text-left'>
                            <div className='sm:flex hidden gap-2 col-span-2 items-center min-w-0'>
                                <p className='truncate'>Payment date</p>
                                <IoArrowDownSharp className='mt-1 text-[16px]' />
                            </div>
                            <div className='sm:flex hidden gap-2 items-center min-w-0'>
                                <p className='truncate'>Type</p>
                                <IoArrowDownSharp className='mt-1 text-[16px]' />
                            </div>
                            <div className='sm:flex hidden items-center justify-end min-w-0'>
                                <p className='truncate'>Amount</p>
                            </div>
                            <div className='min-w-0 sm:block hidden'>
                                <p className='truncate flex justify-center'>Currency</p>
                            </div>
                            <div className='items-center col-span-2 min-w-0'>
                                <p className='truncate'>Sender/Recipient</p>
                            </div>
                            {/* <div className='min-w-0 block sm:hidden'>
                                                    <p className='truncate'>Currency</p>
                                                </div> */}
                            <div className='flex sm:hidden items-center justify-end min-w-0'>
                                <p className='truncate'>Amount</p>
                            </div>
                            <div className='md:flex hidden items-center min-w-0'>
                                <p className='truncate'>Status</p>
                            </div>
                            <div className='sm:flex hidden items-center min-w-0 invisible'>
                                <p className='truncate'>Details</p>
                            </div>
                        </div>
                        {isLoading ? (
                            <div className="flex justify-center items-center h-[20vh]">
                                <p className="text-lg font-medium text-[#531CB3]">Loading transactions...</p>
                            </div>
                        ) : (
                            <>
                                {transaction.length > 0 ? (
                                    transaction.map((transact, index) => (
                                        <div
                                            onClick={isSmScreen ? () => {
                                                setSelectedTransactionDetails(transact)
                                                handleViewTransactionDetails()
                                                handleTransactionClick(transact.id)
                                            }
                                                : undefined}
                                            key={index} className='sm:grid md:grid-cols-9 sm:cursor-auto cursor-pointer sm:hover:bg-white hover:bg-[#F3F0F7] sm:grid-cols-8 sp:grid-cols-7 flex justify-between gap-5 border-b border-[#EAECF0] py-[14px] px-4 text-[14px] text-[#344054] text-left items-center'>
                                            <div className='min-w-0 sm:block hidden col-span-2'>
                                                <p className='truncate'>
                                                    {new Date(transact.date_created).toLocaleDateString("en-GB", {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric',
                                                    })}
                                                </p>
                                            </div>

                                            <div className='min-w-0 sm:flex hidden'>
                                                <p className='truncate'>{transact.type.charAt(0).toUpperCase() + transact.type.slice(1)}</p>
                                            </div>

                                            <div className='min-w-0 sm:block hidden text-right'>
                                                <p className='truncate text-[14px]'>
                                                    {/* {transact.currency === 'USD' ? '$' : '€'} */}
                                                    ${transact.amount}
                                                </p>
                                            </div>

                                            <div className='min-w-0 sm:flex hidden gap-1 items-center justify-center'>
                                                {transact.payment.beneficiary.currency ? (
                                                    <div className='flex gap-1 items-center'>
                                                        <img
                                                            src={currencyLogos[transact.payment.beneficiary.currency]}
                                                            alt={transact.currency}
                                                            className="w-[20px] h-4 rounded-sm"
                                                        />
                                                        {transact.payment.beneficiary.currency}
                                                    </div>
                                                ) : transact.payment.beneficiary.cryptocurrency_type ? (
                                                    <div>
                                                        {transact.payment.beneficiary.cryptocurrency_type}
                                                    </div>
                                                ) : (
                                                    <p>—</p>
                                                )}
                                            </div>

                                            <div className='min-w-0 col-span-2'>
                                                <p className='truncate'>{transact.payment.beneficiary.full_name}</p>
                                                <div className=' flex sm:hidden items-center gap-[2px] text-[12px] text-black/50'>
                                                    <p>
                                                        {new Date(transact.date_created).toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                        })}
                                                    </p>
                                                    <GoDotFill className='text-black text-[8px]' />
                                                    {new Date(transact.date_created).toLocaleDateString("en-GB", {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric',
                                                    })}
                                                </div>
                                            </div>

                                            {/* <div className='min-w-0 flex sm:hidden gap-1 items-center'>
                                            <img
                                                src={currencyLogos[transact.currency]}
                                                alt={transact.currency}
                                                className="w-[20px] h-4 rounded-md"
                                            />
                                            {transact.currency}
                                        </div> */}

                                            <div className='min-w-0 block sm:hidden font-bold text-right'>
                                                <p className={`truncate text-[14px] rounded-full p-[1.4px] flex items-center gap-[1px]
                                                                                      ${transact.type === 'credit' && 'text-[#027A48]'}
                                                                                      ${(transact.type === 'credit' || transact.type === 'debit') && transact.payment.status === 'pending' && 'text-[#B54708]'}
                                                                                      ${transact.type === 'debit' && 'text-red-600'}
                                                                            `}>
                                                    {transact.type !== 'debit' ? <p className='sm:hidden block'>+</p> : <p className='sm:hidden block'>-</p>}
                                                    {/* {transact.currency === 'USD' ? '$' : '€'} */}
                                                    ${transact.amount}
                                                </p>
                                            </div>

                                            <div className='min-w-0 md:block hidden'>
                                                <div
                                                    className={`rounded-xl py-[2px] px-2 flex items-center justify-center w-fit truncate
                                                                                      ${transact.payment.status === 'completed' && 'bg-[#ECFDF3] text-[#027A48]'}
                                                                                      ${transact.payment.status === 'pending' && 'bg-[#FFFAEB] text-[#B54708]'}
                                                                                      ${transact.payment.status === 'failed' && 'bg-red-100 text-red-600'}
                                                                            `}
                                                >
                                                    {transact.payment.status}
                                                </div>
                                            </div>

                                            <div className='min-w-0 sm:flex hidden'>
                                                <button
                                                    className='text-[#542d9d] truncate'
                                                    onClick={() => {
                                                        setSelectedTransactionDetails(transact)
                                                        handleViewTransactionDetails()
                                                        handleTransactionClick(transact.id)
                                                    }}
                                                >
                                                    View Details
                                                </button>
                                            </div>
                                        </div>
                                    ))
                                ) : transaction.length === 0 && verified ? (
                                    <p className='mt-4 text-center font-normal text-lg'>No transaction made yet!</p>
                                ) : transaction.length === 0 && !verified ? (
                                    <div className='mt-4 text-center font-normal'>
                                        <p className='text-lg'>You are yet to verify your KYC details</p>
                                        <p className='mt-2'>
                                            <Link to='/dashboard/getready'>
                                                <span
                                                    className='cursor-pointer text-blue-500 mr-1'>
                                                    Click here
                                                </span>
                                            </Link>

                                            to verify your details
                                        </p>
                                    </div>
                                ) : (
                                    <div></div>
                                )}

                                <div className='my-4 text-[#344054]'>
                                    {transaction?.length} {transaction?.length > 1 ? 'items' : 'item'}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            {viewTransactionDetails && (
                <ViewTransactionDetailsBar
                    className='duration-700 transition-all'
                />
            )}
            <ViewDetailsBar />
        </div>
    )
}

export default Transactions